import type { WillieSupabaseClient } from '@willie/supabase'
import { OPS_BUCKET } from '@willie/supabase/storage'
import { toUploadableImage } from '~/features/installations/heic'
import { randomHex } from '~/utils/random'

const extensionOf = (file: File): string => file.name.split('.').pop()?.toLowerCase() || 'jpg'

/** Stored where the install app puts a contact's index photo, which is the prefix `recordReading` checks. */
export const uploadIndexCapturePhoto = async (
  client: WillieSupabaseClient,
  installationId: number,
  file: File
): Promise<{ storagePath: string }> => {
  const image = await toUploadableImage(file)
  const storagePath = `installations/${installationId}/capture/meter_index-${randomHex(16)}.${extensionOf(image)}`
  const { error } = await client.storage.from(OPS_BUCKET).upload(storagePath, image, {
    contentType: image.type,
    upsert: false
  })
  if (error) throw error
  return { storagePath }
}
